import { render, staticRenderFns } from "./GetAllPages.vue?vue&type=template&id=51a11ab2&"
import script from "./GetAllPages.vue?vue&type=script&lang=js&"
export * from "./GetAllPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports